import { useEffect } from 'react';

/** While `active`, ask the browser to confirm a reload or tab close.
 * In-app navigation is not blocked; callers explain what leaving does. */
export function useBeforeUnloadWarning(active: boolean) {
  useEffect(() => {
    if (!active) {
      return;
    }
    const warn = (event: BeforeUnloadEvent) => {
      event.preventDefault();
      // Legacy browsers only show the prompt when returnValue is set.
      event.returnValue = true;
    };
    window.addEventListener('beforeunload', warn);
    return () => window.removeEventListener('beforeunload', warn);
  }, [active]);
}
